module.exports = __webpack_public_path__ + "trail_bic_black.svg";